import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ft.css";

export default function Featurelist({ data, count, show = "yes" }) {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className={`${count === 1 ? "lg:w-10/12" : ""}`}>
			<li
				className={`${
					count === 1 ? "block md:flex lg:flex gap-5" : "w-full"
				} group`}>
				<Link
					to={`/product/id/${data.style}`}
					state={{
						product: data,
						url: `https://demo.riskydress.com/images/${data.year}/AZURE/`,
						className: "object-cover object-top",
					}}>
					<div
						className={`relative overflow-hidden ${
							count === 1
								? "lg:w-[300px] lg:h-[400px] md:w-[300px] md:h-[400px] w-full"
								: "w-full aspect-[4/5]"
						}`}>
						{/* Main image */}
						<img
							src={
								`https://demo.riskydress.com/images/${data.year}/AZURE/${data.images?.[0]}` ||
								"https://www.amarra.com/cdn/shop/files/89004Nude_Multi_a_1200x.jpg?v=1748346103"
							}
							alt={data.style}
							className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
						/>

						{/* Hover image */}
						<img
							src={
								`https://demo.riskydress.com/images/${data.year}/AZURE/${data.images?.[1]}` ||
								"https://www.amarra.com/cdn/shop/files/89004Nude_Multi_a_1200x.jpg?v=1748346103"
							}
							alt={data.style}
							className="absolute top-0 left-0 w-full h-full object-cover object-top opacity-0 transition-opacity duration-500 group-hover:opacity-100"
						/>

						{/* Black hover overlay */}
						<div className="absolute inset-0 bg-black opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>

						{/* Heading always visible */}
						{show === "yes" && (
							<p className="absolute w-full bottom-0 left-1/2 -translate-x-1/2 text-white  bg-[#3A7BD5] bg-opacity-40  text-lg font-lora font-semibold opacity-100 transition-all duration-500 text-center px-3">
								{data.style}
							</p>
						)}
					</div>
				</Link>

				{/* Description (only for count = 1 layout) */}
				{count === 1 && (
					<div className="mt-3">
						<p className="font-Jost-Regular py-4 text-textlight hidden md:block">
							FABRIC: Soft Slub Khaddar Includes: Shirt Color: Tie dye Size:
							Chart Attached Fit: Regular Fit...
						</p>
						<button className="hidden md:block px-5 py-2 hover:bg-black bg-inherit hover:text-white text-black border-2 border-black rounded-md font-Jost-Regular">
							Select option
						</button>
					</div>
				)}
			</li>
		</div>
	);
}
